@use '@/styles/mastodon/mixins';
@use '@/styles/mastodon/variables';

.wrapper {
  padding-bottom: var(--space-half);
}

@mixin link-base {
  --icon-size: 20px;
  --border-radius: var(--radius-3);

  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--space-2);
  column-gap: var(--space-3);
  border-radius: var(--border-radius);
  border: none;
  color: var(--color-text-primary);
  background-color: transparent;
  transition: background-color 200ms;
  text-decoration: none;
  text-align: start;

  &:where(button, a):hover,
  &:focus-visible,
  &[aria-current='page'] {
    background-color: var(--color-bg-highlight);
    text-decoration: none;
  }

  &:focus-visible {
    outline: var(--outline-focus-default);
  }

  &:focus {
    // Override silly global focus style
    border-radius: var(--border-radius);
  }
}

.link {
  @include link-base;

  min-height: 40px;
  @include mixins.type-body-compact;

  @media (width < variables.$mobile-menu-breakpoint) {
    min-height: 48px;
  }

  &[aria-current='page']:not(:where(.linkStacked, .linkMobile)) {
    font-weight: bold;
  }
}

.linkStacked {
  --icon-size: 24px;

  flex-direction: column;
  row-gap: var(--space-1);
  padding-inline: 0;
  @include mixins.type-micro;
}

.linkMobile {
  --icon-size: 24px;
  --border-radius: var(--radius-round);

  width: 100%;
  justify-content: center;
  gap: 0;
  padding-block: var(--space-3);
  transition:
    background-color 200ms,
    color 200ms;

  &[aria-expanded='true'] {
    color: var(--color-text-inverted);
    background-color: var(--color-bg-inverted);
  }
}

.icon {
  width: var(--icon-size);
  height: var(--icon-size);

  & > svg {
    width: inherit;
    height: inherit;
  }
}

// A dot is shown instead of a number badge on mobile
.iconWithDot {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: var(--space-4xs);
    left: calc(50% + var(--space-half));
    width: var(--space-2);
    height: var(--space-2);
    border-radius: var(--radius-round);
    background-color: var(--color-bg-brand-base);
    border: 1px solid var(--color-bg-primary);
  }
}

.label {
  max-width: 100%;
  min-width: 0;
  flex-grow: 1;
  flex-shrink: 1;
  overflow-wrap: break-word;
  hyphens: auto;

  .linkStacked & {
    text-align: center;
  }
}

.badge {
  .linkStacked & {
    position: absolute;
    top: var(--space-half);
    inset-inline-start: calc(50% + var(--space-half));
  }
}
